import { lazy } from "react";
import { LimpJourneyRoutes } from "../../../../utils/RouterRoutes";

const OtpPage = lazy(() => import("../../../Wizard/JourneyPages/NewOtp"));
const LegalBrillianceBankDetails = lazy(() => import("../JourneyPages/LegalBrillianceBankDetails"));
const LegalBrillianceConsent = lazy(() => import('../JourneyPages/LegalBrillianceConsent'));

export interface JourneyConfig<RouteTypeEnum> {
    path: RouteTypeEnum;
    element: React.ReactElement;
}

export const limpJourney: JourneyConfig<LimpJourneyRoutes>[] = [
    { path: LimpJourneyRoutes.otp, element: <OtpPage /> },
    { path: LimpJourneyRoutes.bankDetails, element: <LegalBrillianceBankDetails /> },
    { path: LimpJourneyRoutes.getCover, element: <LegalBrillianceConsent /> },
]